import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { SettingsProvider } from "@/lib/settings";

import SplashScreen from "@/components/site/SplashScreen";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import CarsList from "@/pages/CarsList";
import CarDetail from "@/pages/CarDetail";
import Financing from "@/pages/Financing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import OrderCar from "@/pages/OrderCar";
import CookiePolicy from "@/pages/CookiePolicy";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsAndConditions from "@/pages/TermsAndConditions";
import DataDeletion from "@/pages/DataDeletion";
import CookieBanner from "@/components/site/CookieBanner";
import ScrollToTop from "@/components/site/ScrollToTop";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCars from "@/pages/admin/AdminCars";
import AdminCarForm from "@/pages/admin/AdminCarForm";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminSettings from "@/pages/admin/AdminSettings";

const withSite = (el) => <SiteLayout>{el}</SiteLayout>;

const SPLASH_KEY = "autorio_splash_shown";

export default function App() {
  // Show premium intro only on the very first visit of the session, on homepage
  const [showSplash, setShowSplash] = useState(() => {
    if (typeof window === "undefined") return false;
    if (window.location.pathname !== "/") return false;
    try {
      if (sessionStorage.getItem(SPLASH_KEY) === "1") return false;
    } catch (_e) {}
    return true;
  });

  useEffect(() => {
    if (showSplash) {
      try {
        sessionStorage.setItem(SPLASH_KEY, "1");
      } catch (_e) {}
    }
  }, [showSplash]);

  return (
    <SettingsProvider>
      <AuthProvider>
        {showSplash && <SplashScreen onFinish={() => setShowSplash(false)} />}
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public */}
            <Route path="/" element={withSite(<Home />)} />
            <Route path="/masini" element={withSite(<CarsList />)} />
            <Route path="/masini/:slug" element={withSite(<CarDetail />)} />
            <Route path="/masini-la-comanda" element={withSite(<OrderCar />)} />
            <Route path="/finantare" element={withSite(<Financing />)} />
            <Route path="/despre" element={withSite(<About />)} />
            <Route path="/contact" element={withSite(<Contact />)} />
            <Route path="/politica-cookie" element={withSite(<CookiePolicy />)} />
            <Route path="/politica-confidentialitate" element={withSite(<PrivacyPolicy />)} />
            <Route path="/termeni-si-conditii" element={withSite(<TermsAndConditions />)} />
            <Route path="/stergere-date" element={withSite(<DataDeletion />)} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="masini" element={<AdminCars />} />
              <Route path="masini/nou" element={<AdminCarForm />} />
              <Route path="masini/:id/editeaza" element={<AdminCarForm />} />
              <Route path="solicitari" element={<AdminInquiries />} />
              <Route path="media" element={<AdminMedia />} />
              <Route path="setari" element={<AdminSettings />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={withSite(<Home />)} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#141414",
              color: "#f5f5f5",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: "12px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: 600,
              fontSize: "13px",
            },
          }}
        />
      </AuthProvider>
    </SettingsProvider>
  );
}
